/* eslint-disable no-sequences */
/* eslint-disable no-unused-expressions */
// @flow
import React, { useEffect, useState, useRef } from 'react';
import type { Element } from 'react';

import { connect } from 'react-redux';

import Head from 'next/head';
import { logout, requestRefreshToken } from '@screens/SignIn/redux/actions';

import { withTranslation } from 'react-i18next';
import { useRouter } from 'next/router';

import { useScrollPosition } from '@n8tb1t/use-scroll-position';

import compose from 'lodash/fp/compose';
import { changeTitle, changeDescription } from '@redux/components/Metadata/actions';
import { setNavbarVisibility, setCurefyDomain } from '@redux/components/Page/actions';

import { cookieService } from '@services';

import type { GlobalState } from '@globalTypes';
import SearchBar from '@components/SearchBar/index';
import waitForPageReady from '@lib/waitForPageReady';

import type { Props } from './types';

import HomeLinkLogo from './components/HomeLinkLogo';
import CurefyLinkLogo from './components/CurefyLinkLogo/index';
import MobileMenu from './components/MobileMenu';
import LoginSignInButtons from './components/LoginSignInButtons';
import NavigationLinks from './components/NavigationLinks';
import { StyledNavigationCover, StyledLinkContainer, SearchIconImg } from './styles';
import CurefyNavigationLinks from './components/CurefyNavigationLinks/index';

const NavigationMain = ({
  personalData,
  setModalOpen,
  doLogout,
  doLogin,
  login,
  t,
  i18n: { language },
  accessToken,
  metadata: { title, description },
  changeTitle,
  changeDescription,
  setNavbarVisibility,
  navbarVisibility,
  curefyDomain
}: Props): Element<any> => {
  const isLoggedIn = accessToken || login.accessToken;
  const username = personalData?.data?.attributes?.first_name || '';
  const email = personalData?.data?.attributes?.email;
  const avatarUrl = personalData?.data?.attributes?.avatar_url || '/images/icons/profile-gray.png';
  const [userScrolled, setUserScroll] = React.useState(false);
  const [mobileUserScrolled, setMobileUserScroll] = React.useState(false);

  const {
    query: { nextRoute: currentRoute },
    pathname
  }: { pathname: string, query: { nextRoute: string } } = useRouter();

  useScrollPosition(({ currPos }) => setUserScroll(currPos.y !== 0), [userScrolled]);

  useScrollPosition(({ currPos }) => {
    // eslint-disable-next-line no-sequences
    setMobileUserScroll(currPos.y < -350), [mobileUserScrolled];
    if (currPos.y >= -4098 && currPos.y <= -1872 && currentRoute === 'index') {
      setMobileUserScroll(false), [mobileUserScrolled];
    }
    if (currPos.y >= -5032 && currPos.y <= -2640 && currentRoute === 'howItWorks') {
      setMobileUserScroll(false), [mobileUserScrolled];
    }
    if (currPos.y >= -1250 && currentRoute === 'detailsTreatment') setMobileUserScroll(false), [mobileUserScrolled];
  });

  useEffect((): void => {
    changeTitle({
      IN: { en: t('DefaultTitle', { lng: 'en' }) }
    });
    changeDescription({
      IN: { en: t('DefaultDescription', { lng: 'en' }) }
    });
  }, [currentRoute]);

  const [searchState, setSearchState] = useState(false);

  const handleSeachIcon = () => {
    setSearchState(!searchState);
  };


  useEffect(() => {
    const userLocation = window.location.href;
    if (userLocation.includes('booking-payment')) {
      setNavbarVisibility(false);
    }
  });
  const [heroSection, setHeroSection] = useState(currentRoute === 'index' && !curefyDomain);
  const isTriggeredRef = useRef(heroSection);
  useEffect(() => {
    if (currentRoute === 'index' && !curefyDomain) {
      const handleScroll = () => {
        const currentScroll = window.scrollY;
        if (currentScroll >= 100) {
          isTriggeredRef.current = false;
          setHeroSection(false);
        } else {
          isTriggeredRef.current = true;
          setHeroSection(true);
        }
      };

      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }
    isTriggeredRef.current = false;
    setHeroSection(false);
    return undefined;
  }, [currentRoute]);

  return (
    <>
      <Head>
        <title>{title.IN[language] || t('DefaultTitle')}</title>
        <meta name="description" content={description.IN[language]} />

        {/* Inline JS for Dropdown */}
        {/* Inline JS for Dropdown */}
        <script
          type="text/javascript"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: `
              var openClass = 'open';

              window.onhashchange = function () {
                var domElementsToClose = document.querySelectorAll(':not([data-dropdown-label=""])');

                for (var i = 0; i < domElementsToClose.length; i++) {
                  var element = domElementsToClose[i];
                  if (element.className && element.className.length) element.className = element.className.replace(openClass, "");
                }
              };

              window.addEventListener('click', function (event) {
                var websiteDropdowns = document.querySelectorAll('.dropdown');
                var isParentsDropdown = false;

                if (!websiteDropdowns || websiteDropdowns.length < 1) return;
        
                for (var i = 0; i < websiteDropdowns.length; i++) {
                  var dropdown = websiteDropdowns[i];

                  if (dropdown.contains(event.target)) {
                    isParentsDropdown = true;
                  }
                }

                var isLink = !!event.target.href && event.target.href.length > 0;

                if ((isParentsDropdown && !isLink)) return null;

                var target = event.target;
                var isDatasetThere = target && target.dataset;
                var isParentNodeNewPresent = target && target.parentNode && target.parentNode.dataset;

                var isMarkedAsAnExempt = 
                  (isDatasetThere && target.dataset.preventDropdownToggle === "true") ||
                  (isParentNodeNewPresent && target.parentNode.dataset.preventDropdownToggle === "true");

                if (isMarkedAsAnExempt) return null;

                if (!isDatasetThere) return null;

                var label = target.dataset.dropdownLabel;

                var elementsToOpenNew = document.querySelectorAll(':not(.open)[data-dropdown-label="' + label + '"]');
                var domElementsToClose = document.querySelectorAll(':not([data-dropdown-label=""]):not([data-dropdown-label="' + label + '"]), .open[data-dropdown-label="' + label + '"]');

                for (var i = 0; i < elementsToOpenNew.length; i++) {
                  var element = elementsToOpenNew[i];
                  element.className += " " + openClass;
                }

                for (var i = 0; i < domElementsToClose.length; i++) {
                  var element = domElementsToClose[i];
                  if (element.className && element.className.length) element.className = element.className.replace(openClass, '');
                }
              });
            `
          }}
        />
        {curefyDomain && (
          <script
            type="text/javascript"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: `

            (function(c,l,a,r,i,t,y){
                c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "mikv5xdyqd");
            `
            }}
          />
        )}
      </Head>

      {navbarVisibility && (
        <>
          <MobileMenu
            username={username}
            email={email}
            avatarUrl={avatarUrl}
            isLoggedIn={isLoggedIn}
            login={accessToken}
            doLogout={doLogout}
            doLogin={doLogin}
            invertCta={mobileUserScrolled}
            routeName={currentRoute}
            setNavbarVisibility={setNavbarVisibility}
            setModalOpen={setModalOpen}
            heroSection={heroSection}
          />
        </>
      )}

      {!navbarVisibility && curefyDomain && (
        <>
          <MobileMenu
            username={username}
            email={email}
            avatarUrl={avatarUrl}
            isLoggedIn={isLoggedIn}
            login={accessToken}
            doLogout={doLogout}
            doLogin={doLogin}
            invertCta={mobileUserScrolled}
            routeName={currentRoute}
            setNavbarVisibility={setNavbarVisibility}
            setModalOpen={setModalOpen}
          />
        </>
      )}


      <StyledNavigationCover id="navigation" heroSection={heroSection}>
        { curefyDomain && (
          <>
            <CurefyLinkLogo />
            <CurefyNavigationLinks
              invertCta={userScrolled}
              doLogin={doLogin}
              isLoggedIn={isLoggedIn}
              doLogout={doLogout}
              username={username}
              pathname={pathname}
            />
          </>
        )}
        { !curefyDomain && <HomeLinkLogo heroSection={heroSection} /> }

        {!curefyDomain && navbarVisibility && (
          <>
            <SearchIconImg heroSection={heroSection} onClick={handleSeachIcon} />
            {searchState && <SearchBar setSearchState={setSearchState} />}

            <StyledLinkContainer>
              { navbarVisibility && (
                <>
                  <NavigationLinks heroSection={heroSection} />
                  {/* <StyledSeparator vertical /> */}
                  <LoginSignInButtons
                    doLogin={doLogin}
                    doLogout={doLogout}
                    isLoggedIn={isLoggedIn}
                    username={username}
                    invertCta={userScrolled}
                    pathname={pathname}
                    setModalOpen={setModalOpen}
                    heroSection={heroSection}
                  />
                </>
              )}
            </StyledLinkContainer>

          </>
        )}
      </StyledNavigationCover>
    </>
  );
};

NavigationMain.getInitialProps = async ({ req, store }) => {
  const accessToken = cookieService.getAccessToken(req);
  store.dispatch(setCurefyDomain(req));
  await waitForPageReady(store);

  return { accessToken };
};

const mapStateToProps = ({
  personalData, login, metadata, page
}: GlobalState): {} => ({
  personalData,
  login,
  metadata,
  navbarVisibility: page.navbarVisibility,
  curefyDomain: page.curefyDomain
});

const mapDispatchToProp = {
  doLogin: requestRefreshToken,
  doLogout: logout,
  changeTitle,
  changeDescription,
  setNavbarVisibility
};

export default compose(
  withTranslation('App'),
  connect(
    mapStateToProps,
    mapDispatchToProp
  )
)(NavigationMain);
